import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem, DebugView } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type IncidentTimePanelItemsProps = {
  incidentId: string;
  purpose: 'Real' | 'Test' | 'Demo';
  createdTimeUtc: string;
  closedTimeUtc: string | null;
  incidentIsReadOnly: boolean;
};

export function IncidentTimePanelItems({
  incidentId,
  purpose,
  createdTimeUtc,
  closedTimeUtc,
  incidentIsReadOnly,
}: IncidentTimePanelItemsProps) {
  const { t } = useTranslation();
  const incidentIsClosed = closedTimeUtc != null;

  return (
    <>
      <DebugView>
        <DataPanelInlineItem title="Incident ID" value={incidentId} allowCopyToClipboard />
        <DataPanelInlineItem title="Purpose" value={purpose} />
      </DebugView>

      <DataPanelInlineItem title={t('Incident_InfoPanel_CreatedTime')}>
        <DateFormatter
          date={createdTimeUtc}
          updateIntervalMs={1000}
          formatType={incidentIsReadOnly ? 'calendar' : 'combined'}
        />
      </DataPanelInlineItem>

      {incidentIsClosed && (
        <DataPanelInlineItem title={t('Incident_InfoPanel_ClosingTime')}>
          <DateFormatter
            date={closedTimeUtc}
            updateIntervalMs={1000}
            formatType={incidentIsReadOnly ? 'calendar' : 'combined'}
          />
        </DataPanelInlineItem>
      )}
    </>
  );
}
